import { render, staticRenderFns } from "./ProductImageManager.vue?vue&type=template&id=ec2f9882&scoped=true"
import script from "./ProductImageManager.vue?vue&type=script&lang=js"
export * from "./ProductImageManager.vue?vue&type=script&lang=js"
import style0 from "./ProductImageManager.vue?vue&type=style&index=0&id=ec2f9882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2f9882",
  null
  
)

export default component.exports